import React, { useEffect, useMemo, useState } from 'react'
import { Button, Card, CardBody, Container, Modal, ModalBody, ModalFooter, ModalHeader, UncontrolledTooltip } from 'reactstrap'
import { SrNo, File, UserName, UploadDate } from './NdaAgreementCol'
import TableContainer from 'components/Common/TableContainer'
import { Link } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { adminGetNdaAgreement } from 'store/actions'
import { useSelector } from 'react-redux'
import Spinners from 'components/Common/Spinner'
import { toast } from 'react-toastify'
const SuperAdminNdaAgreement = () => {
    const dispatch = useDispatch();
    const [showModal, setShowModal] = useState(false)
    const [selectedFile, setSelectedFile] = useState("")
    const toggleModal = () => {
        setShowModal(!showModal)
    }

    const ViewAgreement = (fileUrl) => {
        setSelectedFile(fileUrl)
        setShowModal(true)
    }

    const { Loading, successMsg, errors, agreementList } = useSelector(state => state.AdminNdaAgreementReducer)

    const columns = useMemo(
        () => [
            {
                Header: "Sr No",
                accessor: (row, i) => i + 1,
                filterable: true,
                Cell: cellProps => {
                    return <SrNo {...cellProps} />
                },
            },
            {
                Header: "User Name",
                accessor: "name",
                filterable: true,
                Cell: cellProps => {
                    return <UserName {...cellProps} />
                },
            },
            {
                Header: "File Name",
                accessor: "file_name",
                filterable: true,
                Cell: cellProps => {
                    return <File {...cellProps} />
                },
            },
            {
                Header: "Signed Date",
                accessor: "date",
                filterable: true,
                Cell: cellProps => {
                    return <UploadDate {...cellProps} />
                },
            },
            {
                Header: "Action",
                accessor: "performAction",
                disableFilters: true,
                Cell: cellProps => {
                    return (
                        <ul className="list-unstyled hstack gap-2 mb-0">

                            <li>
                                <Link
                                    to="#"
                                    className="btn btn-sm btn-soft-primary"
                                    onClick={() => ViewAgreement(cellProps.row.original.file)
                                    }
                                    id={`viewtooltip-${cellProps.row.original.id}`}
                                >
                                    <i className="mdi mdi-eye-outline fs-5" />
                                    <UncontrolledTooltip
                                        placement="top"
                                        target={`viewtooltip-${cellProps.row.original.id}`}
                                    >
                                        View
                                    </UncontrolledTooltip>
                                </Link>
                            </li>


                        </ul>)

                },
            },

        ])

    useEffect(() => {
        if (errors && errors !== "") {
            toast.error(errors)
        }
        if (successMsg && successMsg !== "") {
            toast.success(successMsg)
        }
    }, [errors, successMsg])

    useEffect(() => {
        dispatch(adminGetNdaAgreement())
    }, [])

    return (
        <div className='page-content'>
            <Container fluid>
                <Card>
                    <h2 className='mt-2 ms-2'>NDA Agreements</h2>
                    <hr />
                    <CardBody>
                        {
                            Loading ? <Spinners /> :

                                <TableContainer
                                    columns={columns}
                                    data={agreementList || []}
                                    isGlobalFilter={true}
                                    isAddOptions={false}
                                    isJobListGlobalFilter={false}
                                    isPagination={true}
                                    iscustomPageSizeOptions={true}
                                    isShowingPageLength={true}
                                    customPageSize={15}
                                    tableClass="table-bordered align-middle nowrap mt-2"
                                    paginationDiv="col-sm-12 col-md-7"
                                    pagination="pagination justify-content-end pagination-rounded"
                                />}
                    </CardBody>
                </Card>

                <Modal isOpen={showModal} size="xl">
                    <ModalHeader tag={'h4'} toggle={toggleModal}>
                        NDA Agreement
                    </ModalHeader>
                    <ModalBody>

                        <iframe src={`https://docs.google.com/viewer?url=${encodeURIComponent(selectedFile)}&embedded=true`}
                            title="PDF Viewer"
                            width="100%"
                            height="500px"
                        />

                    </ModalBody>
                    <ModalFooter>
                        <Button color='primary float-end' onClick={toggleModal}>Close</Button>
                    </ModalFooter>
                </Modal>
            </Container>
        </div>
    )
}

export default SuperAdminNdaAgreement